export default {
      id: "AddIndicator-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#AddIndicator",
      toString: function () {
        return this.url;
      }
    }